module.exports = __webpack_public_path__ + "static/media/mini.3058fc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程G7E/mini.png
// module id = 708
// module chunks = 0